"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var styles_1 = require("./styles");

var spacing = require("@headspace/hs-web-style-guide/dist/spacing");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var flex = require('@headspace/hs-web-style-guide/dist/flex').default;

function createDescription(description) {
  if (description) {
    return React.createElement("div", __assign({
      className: "radioDescription"
    }, styles_1.labelStyles(colors_1.comet)), description);
  }
}

function RadioField(props) {
  var label = props.label,
      description = props.description,
      options = props.options,
      selectedInputIndex = props.selectedInputIndex,
      onInputSelect = props.onInputSelect;
  var radioInputs = options.map(function (option, idx) {
    var checked = selectedInputIndex === idx ? true : false;

    var onChange = function onChange(idx) {
      return function (event) {
        if (onInputSelect) onInputSelect(idx);
      };
    };

    return React.createElement("input", __assign({}, styles_1.radioButtonStyle, {
      type: "radio",
      name: label,
      value: option,
      key: label + "-" + option,
      defaultChecked: checked,
      onClick: onChange(idx)
    }));
  });
  return React.createElement("div", __assign({}, styles_1.radioWrapperStyles), React.createElement("div", __assign({}, spacing.default.paddingRightSmall), React.createElement("label", __assign({}, font_1.h6, {
    htmlFor: "" + label
  }), label), createDescription(description)), React.createElement("div", __assign({}, flex.flex), radioInputs));
}

exports.RadioField = RadioField;